import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CurrentProductService, ICON_TYPE } from "@spartacus/storefront";
import { combineLatest, Observable, Subscription } from "rxjs";
import { filter, switchMap, take, tap } from "rxjs/operators";
import { GenBundleService } from "../../services/bundle.service";
import { Product, ProductScope } from "@spartacus/core";
import { GenCustomerService } from "../../services/customer.service";
import { GenBundle } from "../../models/bundle.model";
import { GenLoadingEnum } from "../../enums/loading.enum";

@Component({
    selector: 'gen-bundle-carousel',
    templateUrl: './bundle-carousel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenBundleCarouselComponent implements OnInit, OnDestroy {
  bundles: GenBundle[] = [];
  indicatorIcon = ICON_TYPE.CIRCLE;
  previousIcon = ICON_TYPE.CARET_LEFT;
  nextIcon = ICON_TYPE.CARET_RIGHT;
  activeSlide = 0;
  product: Product;
  loading = GenLoadingEnum.Idle;
  GenLoadingEnum = GenLoadingEnum;
  private subscription = new Subscription();

  constructor(
    private currentProductService: CurrentProductService,
    private bundleService: GenBundleService,
    private cdr: ChangeDetectorRef,
    private customerService: GenCustomerService
  ) {
  }

  ngOnInit() {
    this.getBundles();
    this.subscribeToLoadingState();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  trackByBundle(_: number, bundle: GenBundle) {
    return bundle.id;
  }

  addBundleToTheCart(bundle: GenBundle) {
    this.bundleService.addToCart(bundle.id, bundle.product.code)
      .pipe(filter(response => !!response?.error?.message?.length))
      .subscribe(response => {
        bundle.errorMessages = response?.error?.message;
        this.cdr.detectChanges();
      });
  }

  navigateBack() {
    this.hideErrors();
    this.activeSlide -= 1;
  }

  navigateForward() {
    this.hideErrors();
    this.activeSlide += 1;
  }

  private getBundles() {
    this.subscription.add(
      this.customerService.getB2bUnitChanged().pipe(
        switchMap(() => combineLatest([
          this.customerService.getCurrentB2bUnit().pipe(
            filter(unit => !!unit),
            take(1)
          ),
          this.currentProductService.getProduct([
            ProductScope.DETAILS,
            ProductScope.PRICE,
          ])
        ])),
        tap(([_, product]) => this.product = product),
        switchMap(([unit, product]) => this.bundleService.getBundlesWithPrice(unit, product?.code || null)),
      ).subscribe(result => {
          this.bundles = result;
          this.cdr.markForCheck();
        })
    );
  }

  private subscribeToLoadingState() {
    this.subscription.add(
      this.bundleService.loading$
        .subscribe(loading => {
          this.loading = loading;
          this.cdr.markForCheck();
        })
    );
  }

  private hideErrors() {
    if (this.bundles[this.activeSlide].errorMessages?.length) {
      this.bundles[this.activeSlide].errorMessages = null;
    }
  }

}
